<script lang="ts">
  import SellSheetsIndex from "@retailer/svelte/SellSheets/SellSheetsIndex.svelte";
  import Spinner from "@shared/svelte/Components/SpinnerInternal.svelte";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";

  const sellsheetsRes = async () => {
    let res = [];
    res = await HttpPromise({
      method: "GET",
      url: "/api/retailer/sell_sheets",
    }).catch(() => (res = []));
    return res;
  };

  const load = async () => {
    const promises = [sellsheetsRes()];

    let results = await Promise.all(promises);

    return {
      sellSheets: results[0],
    };
  };

  let filters = {
    search: null,
    distributor_id: null,
    start_date: null,
    end_date: null,
  };

</script>

{#await load()}
  <Spinner />
{:then data}
  <SellSheetsIndex sellSheets={data.sellSheets} {filters} loadingState={false} />
{/await}
